/* eslint-disable @typescript-eslint/no-namespace */
export namespace ZIndices {
  /** ZIndices Variant Values */
  export type VariantValues = -1 | 10 | 100 | 500 | 1000 | 1100 | 1200 | 1300 | 1400 | 1500 | 2000 | 2100 | 9999999999;

  /** ZIndices Variant Keys */
  export type VariantKeys =
    | 'zNegative1'
    | 'z10'
    | 'z100'
    | 'z500'
    | 'z1000'
    | 'z1100'
    | 'z1200'
    | 'z1300'
    | 'z1400'
    | 'z1500'
    | 'z2000'
    | 'z2100'
    | 'zMax';

  /** ZIndices Variants */
  export type Variants = {
    [Key in VariantKeys]: number;
  };

  /** ZIndices Alias Scale Keys */
  export type AliasScaleKeys = number[] & Partial<Record<VariantKeys, number>>;
}

const zIndices: ZIndices.AliasScaleKeys = [
  -1, 10, 100, 500, 1000, 1100, 1200, 1300, 1400, 1500, 2000, 2100, 9999999999,
];

export const zIndiceAliases: ZIndices.Variants = {
  /** @returns `-1` */
  zNegative1: zIndices[0],
  /** @returns `10` */
  z10: zIndices[1],
  /** @returns `100` */
  z100: zIndices[2],
  /** @returns `500` */
  z500: zIndices[3],
  /** @returns `1000` */
  z1000: zIndices[4],
  /** @returns `1100` */
  z1100: zIndices[5],
  /** @returns `1200` */
  z1200: zIndices[6],
  /** @returns `1300` */
  z1300: zIndices[7],
  /** @returns `1400` */
  z1400: zIndices[8],
  /** @returns `1500` */
  z1500: zIndices[9],
  /** @returns `1400` */
  z2000: zIndices[10],
  /** @returns `1500` */
  z2100: zIndices[11],
  /** @returns `9999999999` */
  zMax: zIndices[12],
};

Object.keys(zIndiceAliases).map(zIndex => {
  const zIndexKey = zIndex as ZIndices.VariantKeys;

  zIndices[zIndexKey] = zIndiceAliases[zIndexKey];
});

export const zIndicesVariants = Object.keys(zIndiceAliases) as ZIndices.VariantKeys[];

export default zIndices;
